// // src/components/ViewProfile.tsx
import React, { useEffect, useState } from 'react'
import { FaEdit, FaLink, FaEnvelope, FaPhone, FaLinkedin } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { OrganizationData } from '../../types/orgProfileTypes'
import { toast } from 'react-toastify'
import { Theme } from '../../lib/theme.ts';
const ViewProfile: React.FC = () => {
  const navigate = useNavigate()
  const [organizationData, setOrganizationData] =
    useState<OrganizationData | null>(null)
  const [bgColor, setBgColor] = useState<string>('')
  const orgId = sessionStorage.getItem('orgId')
  const authToken = sessionStorage.getItem('authToken')
  const [isLoading, setIsLoading] = useState(false)

  const handleEditClick = () => {
    navigate('/edit-organization-profile')
  }

  // Call a GET API to fetch organization data
  useEffect(() => {
    setIsLoading(true)
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      )
      .then((response) => {
        setOrganizationData(response.data)
        setBgColor(response.data.color.P100)
        setIsLoading(false)
      })
      .catch((error) => {
        toast.error('Error fetching organization data', {
          position: 'top-right',
          autoClose: 3000,
        })
      })
  }, [])

  return (
    <>
      {isLoading ? (
<div className="w-full min-h-screen flex items-center justify-center">
  <div
    className="w-10 h-10 border-4 rounded-full animate-spin"
    style={{
      borderTopColor: Theme.colors.button.primary,      // replaces border-t-blue-500
      borderColor: Theme.colors.stroke.weak,            // replaces border-gray-300
      borderTopStyle: 'solid',
      borderRightStyle: 'solid',
      borderBottomStyle: 'solid',
      borderLeftStyle: 'solid',
    }}
  ></div>
</div>

      ) : (
        <div className="bg-gray-100 flex flex-col items-center min-h-screen overflow-hidden scrollbar-none">
          {/* Color Box for Mobile */}
          <div
            className="w-full h-[30vh] lg:hidden"
            style={{
              backgroundColor: bgColor,
            }}
          ></div>

          {/* Main White Box Container for Larger Screens */}
          {/* Main White Box Container for Larger Screens */}
          <div className="hidden lg:flex relative bg-white rounded-lg shadow-xl w-[95%] h-[88vh] justify-center items-center">
            {/* Color Box */}
            <div
              className="absolute top-0 w-[99%] h-1/2 rounded-lg shadow-md"
              style={{ backgroundColor: bgColor }}
            ></div>

            {/* Content Box */}
            <div className="absolute left-1/2 top-1/2 h-[80%] transform -translate-x-1/2 -translate-y-1/2 bg-white p-4 sm:p-4 rounded-lg shadow-lg w-[90%] sm:w-[70%] md:w-[50%] lg:w-[35%] z-10 flex flex-col items-center space-y-8">
              {/* Top Section: Logo, Organization Info */}
              <div className="w-full flex flex-col sm:flex-row items-center sm:items-start space-y-4 sm:space-y-0 sm:space-x-4">
               {/* Circular Logo */}
{organizationData?.logo ? (
  <img
    src={organizationData.logo}
    alt="Organization Logo"
    className="w-24 h-24 rounded-full shadow-md object-contain aspect-auto"
  />
) : (
  <div className="w-24 h-24 rounded-full shadow-md bg-red-400 flex items-center justify-center text-white text-3xl font-bold">
    {organizationData?.companyName?.charAt(0) || "?"}
  </div>
)}


                {/* Organization Info */}
        <div className="text-center sm:text-left">
  {/* Company Name */}
  <h2
    className="text-2xl font-bold"
    style={{ color: Theme.colors.text.strong }} // replaces text-gray-800
  >
    {organizationData?.companyName}
  </h2>

  {/* Tagline */}
  <p
    className="break-words"
    style={{ color: Theme.colors.text.weak }} // replaces text-gray-600
  >
    {organizationData?.tagline}
  </p>

  {/* Sector • Industry */}
  <p
    className="text-sm"
    style={{ color: Theme.colors.stroke.strong }} // replacing text-gray-500 with branded stroke
  >
    {organizationData?.sector} • {organizationData?.industry}
  </p>

  {/* Edit Button */}
  <button
    onClick={handleEditClick}
    className="mt-4 px-4 py-2 rounded-md flex items-center space-x-2 shadow transition"
    style={{
      backgroundColor: Theme.colors.background,
      color: Theme.colors.text.default,
      border: `1px solid ${Theme.colors.stroke.weak}`,
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = Theme.colors.primary;
      e.currentTarget.style.color = Theme.colors.background;
      e.currentTarget.style.border = `1px solid ${Theme.colors.primary}`;
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = Theme.colors.background;
      e.currentTarget.style.color = Theme.colors.text.default;
      e.currentTarget.style.border = `1px solid ${Theme.colors.stroke.weak}`;
    }}
  >
    <FaEdit />
    <span>Edit Profile</span>
  </button>
</div>

              </div>

              {/* Contact Info Section */}
              <div className="flex flex-col space-y-4 w-full justify-between">
                {/* Website Link */}
     <div className="flex items-center space-x-4">
  <FaLink
    className="text-base sm:text-lg"
    style={{ color: Theme.colors.primary }} // icon color
  />
  <div>
    <h4
      className="text-base font-semibold"
      style={{ color: Theme.colors.text.default }} // heading color
    >
      Website Link
    </h4>
    <p
      className="break-words"
      style={{ color: Theme.colors.text.weak }} // paragraph color
    >
      {organizationData?.websiteLink}
    </p>
  </div>
</div>


                {/* Email */}
     <div className="flex items-center space-x-4">
  <FaEnvelope
    className="text-base sm:text-lg"
    style={{ color: Theme.colors.primary }} // dynamic icon color
  />
  <div>
    <h4
      className="text-base font-semibold"
      style={{ color: Theme.colors.text.default }} // dynamic heading color
    >
      Email
    </h4>
    <p
      className="break-words"
      style={{ color: Theme.colors.text.weak }} // dynamic paragraph color
    >
      {organizationData?.contactEmail}
    </p>
  </div>
</div>


                {/* Phone */}
<div className="flex items-center space-x-4">
  <FaPhone
    className="text-base sm:text-lg"
    style={{ color: Theme.colors.primary }} // dynamic icon color
  />
  <div>
    <h4
      className="text-base font-semibold"
      style={{ color: Theme.colors.text.default }} // dynamic heading color
    >
      Phone
    </h4>
    <p
      className="break-words"
      style={{ color: Theme.colors.text.weak }} // dynamic text color
    >
      {organizationData?.contactPhone}
    </p>
  </div>
</div>


                {/* LinkedIn Profile */}
<div className="flex items-center space-x-4">
  <FaLinkedin
    className="text-base sm:text-lg"
    style={{ color: Theme.colors.primary }} // dynamic icon color
  />
  <div>
    <h4
      className="text-base font-semibold"
      style={{ color: Theme.colors.text.default }} // dynamic heading color
    >
      LinkedIn Profile
    </h4>
    <p
      className="break-all"
      style={{ color: Theme.colors.text.weak }} // dynamic link text color
    >
      {organizationData?.linkedinLink}
    </p>
  </div>
</div>

              </div>
            </div>
          </div>

          {/* Mobile View */}
          <div className="relative w-full lg:hidden flex items-center justify-center">
            {/* Content Box */}
  <div
  className="absolute mt-[60%] p-2 sm:p-4 rounded-lg shadow-lg w-[90%] sm:w-[75%] min-h-[65vh] flex flex-col items-center"
  style={{ backgroundColor: Theme.colors.background }}
>
  {/* Top Section */}
  <div className="flex flex-col mb-4 items-center sm:items-start space-y-4">
    {/* Circular Logo or Fallback */}
    {organizationData?.logo ? (
      <img
        src={organizationData.logo}
        alt="Organization Logo"
        className="w-20 h-20 rounded-full shadow-md object-contain aspect-auto"
      />
    ) : (
      <div
        className="w-20 h-20 rounded-full shadow-md flex items-center justify-center text-white text-3xl font-bold"
        style={{
          backgroundColor: Theme.colors.primary,
          color: Theme.colors.background,
        }}
      >
        {organizationData?.companyName?.charAt(0).toUpperCase() || "?"}
      </div>
    )}

    {/* Organization Info */}
    <div className="text-center sm:text-left">
      <h2
        className="text-2xl font-semibold leading-relaxed"
        style={{ color: Theme.colors.text.strong }}
      >
        {organizationData?.companyName}
      </h2>
      <p
        className="break-words"
        style={{ color: Theme.colors.text.weak }}
      >
        {organizationData?.tagline}
      </p>
      <p
        className="text-lg leading-relaxed"
        style={{ color: Theme.colors.stroke.strong }}
      >
        {organizationData?.sector} • {organizationData?.industry}
      </p>
    </div>
  </div>

  {/* Contact Info */}
  <div className="flex flex-col mt-4 space-y-4 w-full flex-grow">
    {/* Website */}
    <div className="flex items-start space-x-4">
      <FaLink
        className="mt-2 text-lg"
        style={{ color: Theme.colors.primary }}
      />
      <div>
        <h4
          className="text-xl font-semibold leading-relaxed"
          style={{ color: Theme.colors.text.default }}
        >
          Website Link
        </h4>
        <p
          className="text-lg break-words leading-relaxed"
          style={{ color: Theme.colors.text.weak }}
        >
          {organizationData?.websiteLink}
        </p>
      </div>
    </div>

    {/* Email */}
    <div className="flex items-start space-x-4">
      <FaEnvelope
        className="mt-2 text-lg"
        style={{ color: Theme.colors.primary }}
      />
      <div>
        <h4
          className="text-xl font-semibold leading-relaxed"
          style={{ color: Theme.colors.text.default }}
        >
          Email
        </h4>
        <p
          className="text-lg break-words leading-relaxed"
          style={{ color: Theme.colors.text.weak }}
        >
          {organizationData?.contactEmail}
        </p>
      </div>
    </div>

    {/* Phone */}
    <div className="flex items-start space-x-4">
      <FaPhone
        className="mt-2 text-lg"
        style={{ color: Theme.colors.primary }}
      />
      <div>
        <h4
          className="text-xl font-semibold leading-relaxed"
          style={{ color: Theme.colors.text.default }}
        >
          Phone
        </h4>
        <p
          className="text-lg break-words leading-relaxed"
          style={{ color: Theme.colors.text.weak }}
        >
          {organizationData?.contactPhone}
        </p>
      </div>
    </div>

    {/* LinkedIn */}
    <div className="flex items-start space-x-4">
      <FaLinkedin
        className="mt-2 text-lg"
        style={{ color: Theme.colors.primary }}
      />
      <div>
        <h4
          className="text-xl font-semibold leading-relaxed"
          style={{ color: Theme.colors.text.default }}
        >
          LinkedIn Profile
        </h4>
        <p
          className="text-lg break-words leading-relaxed"
          style={{ color: Theme.colors.text.weak }}
        >
          {organizationData?.linkedinLink}
        </p>
      </div>
    </div>
  </div>

  {/* Edit Button */}
  <button
    onClick={handleEditClick}
    className="w-full mt-4 px-4 py-3 rounded-lg flex items-center justify-center space-x-2 shadow transition"
    style={{
      backgroundColor: Theme.colors.background,
      color: Theme.colors.text.default,
      border: `1px solid ${Theme.colors.stroke.weak}`,
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = Theme.colors.primary;
      e.currentTarget.style.color = Theme.colors.background;
      e.currentTarget.style.border = `1px solid ${Theme.colors.primary}`;
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = Theme.colors.background;
      e.currentTarget.style.color = Theme.colors.text.default;
      e.currentTarget.style.border = `1px solid ${Theme.colors.stroke.weak}`;
    }}
  >
    <FaEdit />
    <span>Edit Profile</span>
  </button>
</div>

          </div>
        </div>
      )}
    </>
  )
}

export default ViewProfile
